export const useMetrika = (type) => {
  const metrika = useState("metrika");

  //console.log(metrika.value, "reachGoal", type)
  if (window.ym && metrika.value) ym(metrika.value, "reachGoal", type);
};
